export default __webpack_public_path__ + "static/20250512-afd18f67c8778dfb095ba2aea90093b0.png";